import { css, LitElement, svg } from "lit";
export class Icon extends LitElement {
    constructor() {
        super();
        this.size = "lg";
        this.variant = "outlined";
        this._iconSizes = {};
        this._renderedIcon = svg ``;
    }
    render() {
        return svg `
      <svg viewBox=${this.viewBox} xmlns="http://www.w3.org/2000/svg">
        ${this._renderedIcon}
      </svg>
    `;
    }
    updated(_changedProperties) {
        super.updated(_changedProperties);
        if (_changedProperties.has("size") || _changedProperties.has("variant")) {
            this.loadIcon(this.size, this.variant);
        }
    }
    connectedCallback() {
        super.connectedCallback();
        for (const size of ["sm", "md", "lg", "xl", "2xl"]) {
            // query the dom for the value of the css variable
            const sizeValue = getComputedStyle(this).getPropertyValue(`--lens-semantic-icon-size-${size}`);
            // store the value in the sizes object
            this._iconSizes[size] = sizeValue;
        }
        const forcedSize = getComputedStyle(this).getPropertyValue(`--atlas-icon-size`);
        if (forcedSize.length) {
            this.size = forcedSize.trim();
        }
        this.requestUpdate();
    }
    get sizeValue() {
        return this._iconSizes[this.size] ?? "24px";
    }
    get viewBox() {
        const size = parseInt(this.sizeValue) || 24;
        return `0 0 ${size} ${size}`;
    }
    static define(name, icon) {
        const tagName = `dil-${name}-icon`;
        if (customElements.get(tagName)) {
            return;
        }
        customElements.define(tagName, icon);
    }
}
Icon.properties = {
    size: { type: String, reflect: true },
    variant: { type: String, reflect: true },
    _iconSizes: { state: true },
    _renderedIcon: { state: true },
};
Icon.styles = css `
    :host {
      display: inline-flex;
    }
    :host([hidden]) {
      display: none;
    }
    :host([size="sm"]) svg {
      width: var(--lens-semantic-icon-size-sm);
      height: var(--lens-semantic-icon-size-sm);
    }
    :host([size="md"]) svg {
      width: var(--lens-semantic-icon-size-md);
      height: var(--lens-semantic-icon-size-md);
    }
    :host([size="lg"]) svg {
      width: var(--lens-semantic-icon-size-lg);
      height: var(--lens-semantic-icon-size-lg);
    }
    :host([size="xl"]) svg {
      width: var(--lens-semantic-icon-size-xl);
      height: var(--lens-semantic-icon-size-xl);
    }
    :host([size="2xl"]) svg {
      width: var(--lens-semantic-icon-size-2xl);
      height: var(--lens-semantic-icon-size-2xl);
    }
  `;
